import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './OpenOrdersFilter.scss';

const hpoolFilters = [
  { id: '', title: 'All' },
  { id: 'BUY_LIMIT', title: 'Limit Buy' },
  { id: 'SELL_LIMIT', title: 'Limit Sell' },
  { id: 'STOP_LOSS', title: 'StopLoss' },
];

const Filter = ({ currentActive, filter, onClick }) => {
  const active = filter.id === currentActive;
  const className = clsx({ active });
  return (
    <span key={filter.id} onClick={() => onClick(filter.id)} className={className}>
      {filter.title}
    </span>
  );
};

Filter.propTypes = {
  currentActive: PropTypes.string.isRequired,
  filter: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default function OrdersFilters({ onChange, currentFilter, filters, className, ...rest }) {
  return (
    <div className={clsx('filters-wrapper', className)}>
      {filters.map((filter) => (
        <Filter filter={filter} onClick={onChange} currentActive={currentFilter} key={filter.id} />
      ))}
    </div>
  );
}

OrdersFilters.defaultProps = {
  filters: hpoolFilters,
  className: '',
};

OrdersFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentFilter: PropTypes.string.isRequired,
  className: PropTypes.string,
  filters: PropTypes.array,
};
